import React from 'react';
type OrnamentProps = {
  className?: string;
  align?: 'center' | 'left';
};
export function Ornament({
  className = '',
  align = 'center'
}: OrnamentProps) {
  return <div className={`flex items-center gap-2 ${align === 'center' ? 'justify-center' : 'justify-start'} ${className}`} aria-hidden="true" data-id="element-213" data-mp="gubytfy06e8y">
      <span className="h-px w-10 bg-accent/70" data-id="element-214" data-mp="71enbtrfhpju" />
      <span className="h-1.5 w-1.5 rotate-45 bg-accent" data-id="element-215" data-mp="30kzf0dzkaqy" />
      <span className="h-px w-10 bg-accent/70" data-id="element-216" data-mp="325rmjctvhln" />
    </div>;
}